// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2i8Wc","clinicsSelect":"TableHeading_clinicsSelect__3rUs7"};